import React, { useEffect, useState } from 'react';
import { Table, message, Input, Form, Modal } from 'antd';
import { AiOutlinePlus, AiOutlineDelete } from 'react-icons/ai';
import DeleteModal from '../../Components/Modal/DeleteModal';
import Service from '../../../../Service';
import usePermission from '../../../../Utils/usePermission';

const ExpenseCategories = () => {
    const [form] = Form.useForm();
    const { canCreate, canDelete } = usePermission();
    const [selectedId, setSelectedId] = useState(null);
    const [isAddModal, setIsAddModal] = useState(false);
    const [isDeleteModal, setIsDeleteModal] = useState(false);
    const [update, setUpdate] = useState(false);
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [addLoading, setAddLoading] = useState(false);

    useEffect(() => {
        fetchCategories();
    }, [update]);

    const fetchCategories = async () => {
        setLoading(true);
        try {
            const service = new Service();
            const response = await service.ExpenseService.getExpenseCategories();
            setCategories(response);
        } catch (error) {
            message.error('Kategoriler yüklenirken hata oluştu');
        } finally {
            setLoading(false);
        }
    };

    const onDeleteCategory = (id) => {
        setSelectedId(id);
        setIsDeleteModal(true);
    };

    const handleDelete = async () => {
        try {
            const service = new Service();
            await service.ExpenseService.deleteExpenseCategory(selectedId);
            message.success('Kategori başarıyla silindi');
            setUpdate(!update);
            setIsDeleteModal(false);
        } catch (error) {
            message.error('Kategori silinirken hata oluştu');
        }
    };

    const handleAddCategory = async (values) => {
        setAddLoading(true);
        try {
            const service = new Service();
            await service.ExpenseService.createExpenseCategory(values);
            message.success('Kategori başarıyla eklendi');
            form.resetFields();
            setIsAddModal(false);
            setUpdate(!update);
        } catch (error) {
            message.error('Kategori eklenirken hata oluştu');
        } finally {
            setAddLoading(false);
        }
    };

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            width: 80,
        },
        {
            title: 'Kategori Adı',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'İşlemler',
            key: 'actions',
            align: 'center',
            width: 100,
            render: (_, record) => (
                <div className="flex justify-center">
                    {canDelete && (
                        <button
                            className="bg-red-500 hover:bg-red-700 text-white font-bold py-1 px-3 rounded text-sm"
                            onClick={() => onDeleteCategory(record.id)}
                        >
                            <AiOutlineDelete />
                        </button>
                    )}
                </div>
            ),
        },
    ];

    return (
        <div>
            <div className="flex justify-between items-center mb-4">
                <h1 className="text-2xl font-bold">Harcama Kategorileri</h1>
                <div>
                    {canCreate && (
                        <button
                            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded flex items-center"
                            onClick={() => setIsAddModal(true)}
                        >
                            <AiOutlinePlus className="mr-2" />
                            Yeni Kategori
                        </button>
                    )}
                </div>
            </div>

            <Table
                columns={columns}
                dataSource={categories}
                rowKey="id"
                loading={loading}
                pagination={{
                    showSizeChanger: false,
                    showTotal: (total, range) => `${range[0]}-${range[1]} / ${total} kategori`,
                }}
            />

            <Modal
                title="Yeni Kategori Ekle"
                open={isAddModal}
                onCancel={() => {
                    setIsAddModal(false);
                    form.resetFields();
                }}
                footer={null}
                width={400}
            >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleAddCategory}
                    initialValues={{
                        name: '',
                    }}
                >
                    <Form.Item
                        label="Kategori Adı"
                        name="name"
                        rules={[
                            { required: true, message: 'Kategori adı zorunludur' },
                            { min: 2, message: 'Kategori adı en az 2 karakter olmalıdır' },
                        ]}
                    >
                        <Input placeholder="Kategori adı giriniz" />
                    </Form.Item>

                    <Form.Item>
                        <div className="flex justify-end space-x-2">
                            <button
                                className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
                                onClick={() => {
                                    setIsAddModal(false);
                                    form.resetFields();
                                }}
                            >
                                İptal
                            </button>
                            <button
                                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                                type="submit"
                                disabled={addLoading}
                            >
                                {addLoading ? 'Kaydediyor...' : 'Kaydet'}
                            </button>
                        </div>
                    </Form.Item>
                </Form>
            </Modal>

            <DeleteModal
                isOpen={isDeleteModal}
                onClose={() => setIsDeleteModal(false)}
                onDelete={handleDelete}
                title="Kategori Sil"
                description="Bu kategoriyi silmek istediğinizden emin misiniz?"
            />
        </div>
    );
};

export default ExpenseCategories; 